import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="renters"
export default class extends Controller {
  showCalendar(event) {
    console.log("showCalendar")
    event.preventDefault();
    document.getElementById("calendar_button").classList.add("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("calendar_img").classList.remove("hidden");
    document.getElementById("calendar_tab").classList.remove("hidden");
    document.getElementById("counts_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("counts_tab").classList.add("hidden");
    document.getElementById("counts_img").classList.add("hidden");
    document.getElementById("messages_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("messages_tab").classList.add("hidden");
    document.getElementById("messages_img").classList.add("hidden");
    document.getElementById("analitics_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("analitics_tab").classList.add("hidden");
    document.getElementById("analitics_img").classList.add("hidden");
  }
  showCounts(event) {
    console.log("showCounts")
    event.preventDefault();
    document.getElementById("calendar_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("calendar_img").classList.add("hidden");
    document.getElementById("calendar_tab").classList.add("hidden");
    document.getElementById("counts_button").classList.add("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("counts_tab").classList.remove("hidden");
    document.getElementById("counts_img").classList.remove("hidden");
    document.getElementById("messages_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("messages_tab").classList.add("hidden");
    document.getElementById("messages_img").classList.add("hidden");
    document.getElementById("analitics_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("analitics_tab").classList.add("hidden");
    document.getElementById("analitics_img").classList.add("hidden");
  }
  showMessages(event) {
    console.log("showMessages")
    event.preventDefault();
    document.getElementById("calendar_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("calendar_img").classList.add("hidden");
    document.getElementById("calendar_tab").classList.add("hidden");
    document.getElementById("counts_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("counts_tab").classList.add("hidden");
    document.getElementById("counts_img").classList.add("hidden");
    document.getElementById("messages_button").classList.add("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("messages_tab").classList.remove("hidden");
    document.getElementById("messages_img").classList.remove("hidden");
    document.getElementById("analitics_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("analitics_tab").classList.add("hidden");
    document.getElementById("analitics_img").classList.add("hidden");
  }
  showAnalitics(event) {
    console.log("showAnalitics")
    event.preventDefault();
    document.getElementById("calendar_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("calendar_img").classList.add("hidden");
    document.getElementById("calendar_tab").classList.add("hidden");
    document.getElementById("counts_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("counts_tab").classList.add("hidden");
    document.getElementById("counts_img").classList.add("hidden");
    document.getElementById("messages_button").classList.remove("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("messages_tab").classList.add("hidden");
    document.getElementById("messages_img").classList.add("hidden");
    document.getElementById("analitics_button").classList.add("bg-white", "lg:bg-white/10", "lg:ring-1", "lg:ring-inset", "lg:ring-white/10");
    document.getElementById("analitics_tab").classList.remove("hidden");
    document.getElementById("analitics_img").classList.remove("hidden");
  }
}
